import { createApp, inject, provide } from "vue";
import productsList from "./ProductList.vue";

const app = createApp({
  components: {
    "products-list": productsList,
  },
}).mount("#component-produtos");

